import React, { Component } from "react";
import { HeaderTop, FormPasswordChange } from "../../components";
import "./styles.css";

class Profile extends Component {
  render() {
    return (
      <div className="profile">

        <HeaderTop />

        <div className="content content-profile">

          <div className="content-box">
            
            <h1>Смени парола</h1>
            <FormPasswordChange />

          </div>
        </div>

        <div className="bg-1" />
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/screens/Profile/Profile.js